import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFoodBell: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconFoodBell"><Path d="M2.5 18.5H21.5" stroke="currentColor" strokeLinecap="square"/><Path d="M9.5 19H14.5" stroke="currentColor" strokeLinecap="square"/><Path d="M2.49945 16.5H21.4995C21.9994 1.5 1.99951 1.5 2.49945 16.5Z" stroke="currentColor"/><Path d="M12 4.5V5.25" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconFoodBell;
